<!--
  @Author: DKing
  @Desc: 元素标准,
  @Date: 2019-07-17
-->

<template>
    <div class="page-main">
      <h1>元素标准表</h1>
      <p>
        <button class="btnFullColor">常规</button>
        <button class="btnFullColorDisabled">禁用</button>
      </p>
      <p>
        <button class="btnLineFontColor">常规</button>
        <button class="btnLineFontColorDisabled">禁用</button>
      </p>
      <p>
        <button class="btnLineColor">常规</button>
        <button class="btnLineColorDisabled">禁用</button>
      </p>
      <p>
        <button class="btnNoBorderBlue">常规</button>
        <button class="btnNoBorderBlueDisabled">禁用</button>
      </p>
      <p>
        <button class="btnNoBorderRed">常规</button>
        <button class="btnNoBorderRedDisabled">禁用</button>
      </p>
      <p>
        <button class="btnNoBorderGreen">常规</button>
        <button class="btnNoBorderGreenDisabled">禁用</button>
      </p>
      <p>
        <button class="btnLargeFullColor">长按钮</button>
        <button class="btnLargeLineColor">批次提交</button>
        <button class="btnLargeLineColorIcon"><img src="../../../static/icons/ic_btn_download.png"/>模板下载</button>
        <button class="btnLargeLineColorIcon"><img src="../../../static/icons/ic_btn_add.png"/>导入数据</button>
      </p>

    </div>
</template>

<script>
    export default {
        name: "dom-standard",
        components: {},

        computed: {},

        data() {
            return {}
        },

        created() {

        },

        mounted() {

        },

        methods: {
            // xhr -- [http方法请加 xhr  前缀]
            xhrGoodsList() {
                // 这是ajax的函数，do things
            }
        }

    }
</script>
<style lang="scss" scoped>
    @import "../../styles/variable";

</style>



// WEBPACK FOOTER //
// src/views/staticPages/domStandard.vue